
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.578 3.11A2.5 2.5 0 005 4.5v2c0 .546.175 1.05.472 1.462l4.106-4.853zM4.566 9.031c-.103-.12-.2-.247-.289-.38a.625.625 0 10-1.038.696c.153.23.325.446.513.647l.814-.963zm1.305 2.329l.893-1.056a3.87 3.87 0 003.959-1.653.625.625 0 011.039.696A5.12 5.12 0 015.87 11.36zm2.023-2.392L10 6.481V6.5a2.5 2.5 0 01-2.106 2.47zM6 12.375a.625.625 0 100 1.25h3a.625.625 0 100-1.25H6z","fill":"#fff"}}),_c('path',{attrs:{"d":"M11 3L3 13","stroke":"#fff","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    